import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../admin.service';

@Component({
    selector: 'app-list-banner',
    templateUrl: './list-banner.html',
    styleUrls: ['./list-banner.css']
})

export class ListBanner implements OnInit {
    allBannerList: any;
    allBannerListMaster: any;
    filterStatus = 'allBanner';
    searchValue = '';
    ngOnInit(): void {
        this.getAllBanner();
    }
    constructor(private adminService: AdminService) { }
    getAllBanner() {
        this.adminService.getAllBanners(1000, 0).subscribe(
            (res) => {
                this.allBannerList = res.data;
                this.allBannerListMaster = res.data;
            }
        )
    }
    triggerChangeStatus(status, bannerId) {
        let reqBody = {
            status
        }
        this.adminService.updateBanner(reqBody, bannerId).subscribe(
            (res) => {
                this.getAllBanner();
            },
            (err) => {
                this.getAllBanner();
            }
        )
    }
    shortAccToStatus(status) {
        this.filterStatus = status;
        if (status === 'allBanner') {
            this.allBannerList = this.allBannerListMaster;
        } else if (status === 'Active') {
            this.allBannerList = this.allBannerListMaster.filter(banner => banner.status === 'ACTIVE');
        } else {
            this.allBannerList = this.allBannerListMaster.filter(banner => banner.status === 'INACTIVE');
        }
    }

    searchBannerByInput() {
        if (this.searchValue != '') {
            this.filterStatus = 'allBanner';
            this.allBannerList = this.allBannerListMaster.filter(banner => banner.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        }
        else 
        this.allBannerList = this.allBannerListMaster;
    }

}
